import { render, staticRenderFns } from "./SampleTestPackageTable.vue?vue&type=template&id=31e95d76"
import script from "./SampleTestPackageTable.vue?vue&type=script&lang=js"
export * from "./SampleTestPackageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports